import { objectfyArray } from "../helpers/objectfyArray";

const storeSettings = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_STORE_SETTINGS":
      return action.storeSettings;

    case "REMOVE_STORE_SETTINGS":
      return {};
    default:
      return state;
  }
};

export default storeSettings;
